document.addEventListener('DOMContentLoaded', function () {
const navi = document.getElementById('navi');
const sprite = document.getElementById('navi-sprite');

if (!navi || !sprite) return;

const cellWidth = 192;
const cellHeight = 208;

const animations = {
idle: {
row: 0,
frames: 6,
speed: 180,
loop: true
},
wave: {
row: 3,
frames: 4,
speed: 220,
loop: false
},
jump: {
row: 4,
frames: 5,
speed: 140,
loop: false
},
waiting: {
row: 6,
frames: 6,
loop: false
}
};

let timer = null;
let lookTimeout = null;
let currentAnimation = 'idle';
let isLooking = false;
let lastDirection = null;
let blinkTimeout = null;
let waitTimeout = null;
function setFrame(row, frame) {
const x = -(frame * cellWidth);
const y = -(row * cellHeight);

sprite.style.backgroundPosition = x + 'px ' + y + 'px';
}

function playAnimation(name) {
const animation = animations[name];

if (!animation) return;

clearInterval(timer);
clearTimeout(lookTimeout);

isLooking = false;
currentAnimation = name;

if (name === 'idle') {
setFrame(0, 0);
return;
}

let frame = 0;

setFrame(animation.row, frame);

timer = setInterval(function () {
frame += 1;

if (frame >= animation.frames) {
if (animation.loop) {
frame = 0;
} else {
clearInterval(timer);
playAnimation('idle');
return;
}
}

setFrame(animation.row, frame);
}, animation.speed);
}

function wave() {
if (currentAnimation !== 'wave') {
playAnimation('wave');
}
}
function blink() {
if (currentAnimation !== 'idle') return;

currentAnimation = 'blink';

const blinkFrames = [0, 1, 2, 3, 4, 5, 0];
let step = 0;

setFrame(0, blinkFrames[step]);

timer = setInterval(function () {
step += 1;

if (step >= blinkFrames.length) {
clearInterval(timer);
currentAnimation = 'idle';
setFrame(0, 0);
return;
}

setFrame(0, blinkFrames[step]);
}, 80);
}

function scheduleBlink() {
const delay = 6000 + Math.random() * 6000;

blinkTimeout = setTimeout(function () {
blink();
scheduleBlink();
}, delay);
}

function lookAt(x, y) {
if (currentAnimation === 'wave' || currentAnimation === 'jump') {
return;
}

const rect = navi.getBoundingClientRect();

const centerX = rect.left + rect.width / 2;
const centerY = rect.top + rect.height / 2;

const dx = x - centerX;
const dy = y - centerY;

const distance = Math.sqrt(dx * dx + dy * dy);

if (distance < 40) {
return;
}

clearInterval(timer);

isLooking = true;
currentAnimation = 'look';

let degrees =
Math.atan2(dx, -dy) * (180 / Math.PI);

if (degrees < 0) {
degrees += 360;
}

let direction =
Math.round(degrees / 22.5) % 16;
/*
Smooth the upper-left approach.
Hold the 337.5° pose instead of snapping
into the front-facing 000° frame.
*/

lastDirection = direction;

let row;
let frame;

if (direction < 8) {
row = 9;
frame = direction;
} else {
row = 10;
frame = direction - 8;
}

/*
Tiny registration corrections.
These compensate for NAVI shifting inside
some of the left-side sprite cells.
*/
const xCorrection = [
0, 0, 0, 0,
0, 0, 0, 0,
0, 0, -1, -1,
-2, -4, -6, -8
 ];

const yCorrection = [
0, 0, 0, 0,
0, 0, 0, 0,
0, 0, 0, 0, 
-0, -0, -1, -2
 ];

const baseX = -(frame * cellWidth);
const baseY = -(row * cellHeight);

sprite.style.backgroundPosition =
(baseX + xCorrection[direction]) + 'px ' +
(baseY + yCorrection[direction]) + 'px';

clearTimeout(lookTimeout);

lookTimeout = setTimeout(function () {
lastDirection = null;

if (isLooking) {
playAnimation('idle');
}
}, 900);
}

document.addEventListener('mousemove', function (event) {
lookAt(event.clientX, event.clientY);
});

navi.addEventListener('keydown', function (event) {
if (event.key === 'Enter' || event.key === ' ') {
event.preventDefault();
wave();
}
});
const message = document.getElementById('navi-message');
let messageTimeout = null;

navi.addEventListener('click', function () {
if (!message) return;

message.classList.add('navi__message--show');

clearTimeout(messageTimeout);

messageTimeout = setTimeout(function () {
message.classList.remove('navi__message--show');
}, 2500);
});
scheduleBlink();

playAnimation('idle');
});